<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center flex-fill">
        <h5 class="modal-title">
          AI Settings
          <a class="mx-2 text-dark" href="http://tokeet.com/help/tokeet-ai/activating-tokeet-ai" target="_blank">
            <i
              class="fal fa-info-circle"
              matTooltip="Click here to see the associated help article."
              matTooltipPosition="above"
            ></i>
          </a>
          <app-page-help videoId="mt1mm-Y0hiA"></app-page-help>
        </h5>
        <div class="flex-fill"></div>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fas fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="alert alert-warning" *ngIf="aiSettings?.contractId && !aiSettings?.isContractSigned">
        Please sign the contract to use TokeetAI feature. If you have signed the contract, please click the Refresh
        button to refresh the AI settings.

        <button class="btn btn-cst-info ml-3" (click)="onRefreshSettings()">Refresh</button>
        <button class="btn btn-cst-warning ml-3" (click)="onSignAIContract()">Sign</button>
      </div>
      <div class="d-flex align-items-center">
        <div class="text-uppercase">Train Your AI</div>
        <div class="flex-fill"></div>
        <button
          class="btn btn-cst-info text-uppercase px-3"
          matTooltip="Try out the AI! Ask a question and see how it responds."
          [popover]="test"
          #testPop="bs-popover"
          (onHidden)="testForm.reset()"
          [adaptivePosition]="false"
          placement="bottom"
          containerClass="border rounded ai-test-popover"
          style="margin-right: 2rem; font-size: 11px"
        >
          <svg-icon
            src="assets/images/icons/ai-solid.svg"
            [svgStyle]="{ 'width.px': 14 }"
            class="d-inline mr-2"
          ></svg-icon>
          Test AI
        </button>
        <app-form-switch
          matTooltip="Switch the TokeetAI feature on or off here."
          label="TokeetAI"
          [ctrl]="togglesForm.get('isEnabled')"
          [disabled]="!aiSettings?.isContractSigned && aiSettings?.contractId"
        ></app-form-switch>
      </div>
      <div class="mt-1 bg-white border position-relative overflow-hidden" style="border-radius: 0.5rem">
        <div class="d-flex flex-wrap-reverse align-items-center border-bottom">
          <ul class="tab-list">
            <li [class.active]="activeTab === 0" (click)="activeTab = 0">
              <a matTooltip="Upload Docs & add FAQs to train TokeetAI.">Knowledge Base</a>
              <a href="http://tokeet.com/help/tokeet-ai/tokeet-ai-knowledgebase" target="_blank">
                <i
                  class="fal fa-info-circle ml-2"
                  matTooltip="Click here to see the associated help article."
                  matTooltipPosition="above"
                ></i>
              </a>
            </li>
            <li [class.active]="activeTab === 1" (click)="activeTab = 1">
              <a matTooltip="Edit settings of TokeetAI related features.">Settings</a>
              <a href="http://tokeet.com/help/tokeet-ai/tokeet-ai-settings" target="_blank">
                <i
                  class="fal fa-info-circle ml-2"
                  matTooltip="Click here to see the associated help article."
                  matTooltipPosition="above"
                ></i>
              </a>
            </li>
            <li [class.active]="activeTab === 2" (click)="activeTab = 2">
              <a matTooltip="Control permissions for TokeetAI on all rental related fields.">Rental Details</a>
              <a href="http://tokeet.com/help/tokeet-ai/tokeet-ai-rental-information" target="_blank">
                <i
                  class="fal fa-info-circle ml-2"
                  matTooltip="Click here to see the associated help article."
                  matTooltipPosition="above"
                ></i>
              </a>
            </li>
            <li [class.active]="activeTab === 3" (click)="activeTab = 3">
              <a
                matTooltip="Block specific Booking conversation, Email address, Rental or Regex from TokeetAI auto responses."
                >Ignore List</a
              >
              <a href="http://tokeet.com/help/tokeet-ai/tokeet-ai-ignore-list" target="_blank">
                <i
                  class="fal fa-info-circle ml-2"
                  matTooltip="Click here to see the associated help article."
                  matTooltipPosition="above"
                ></i>
              </a>
            </li>
            <li [class.active]="activeTab === 4" (click)="activeTab = 4">
              <a matTooltip="Control AI subscription, recharge & balance options"> Credit Recharge</a>
              <a href="https://www.tokeet.com/help/tokeet-ai/tokeet-ai-payments" target="_blank"
                ><i
                  class="fal fa-info-circle ml-2"
                  matTooltip="Click here to see the associated help article."
                  matTooltipPosition="above"
                ></i
              ></a>
            </li>
          </ul>
          <div class="flex-fill"></div>
          <app-form-switch
            label="Automatically send AI replies"
            [ctrl]="togglesForm.get('isAutomateSendReplies')"
            matTooltip="Enable this toggle for automatically sending AI based messages to guests"
            class="ml-auto"
          ></app-form-switch>
        </div>
        <ng-template [ngTemplateOutlet]="base" *ngIf="activeTab === 0"></ng-template>
        <ng-template [ngTemplateOutlet]="settings" *ngIf="activeTab === 1"></ng-template>
        <ng-container *ngIf="activeTab === 2">
          <app-ai-responder-rental-details [settings]="aiSettings"></app-ai-responder-rental-details>
        </ng-container>
        <ng-container *ngIf="activeTab === 3">
          <app-ai-responder-ignore-list [settings]="aiSettings"></app-ai-responder-ignore-list>
        </ng-container>
        <ng-container *ngIf="activeTab === 4">
          <app-ai-auto-credit-recharge></app-ai-auto-credit-recharge>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<ng-template #base>
  <mat-accordion [hideToggle]="true" class="m-4 d-block border overflow-hidden" style="border-radius: 0.5rem">
    <!-- <mat-expansion-panel class="border-bottom rounded-0 shadow-none m-0" [expanded]="true" #panel1>
      <mat-expansion-panel-header [class.border-bottom]="panel1.expanded">
        <mat-panel-title class="text-uppercase d-flex align-items-center">
          <i class="fas mr-1" [ngClass]="'fa-caret-' + (panel1.expanded ? 'down' : 'right')"></i> Websites
        </mat-panel-title>
        <mat-panel-description class="d-flex" (click)="$event.stopPropagation()">
          <div class="flex-fill"></div>
          <app-form-switch
            label="Active"
            [labelReverse]="true"
            [ctrl]="togglesForm.get('isWebsitesEnabled')"
          ></app-form-switch>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ai-responder-websites [websites]="aiSettings?.urls"></ai-responder-websites>
    </mat-expansion-panel> -->
    <mat-expansion-panel class="border-bottom rounded-0 shadow-none m-0" [expanded]="true" #panel2>
      <mat-expansion-panel-header [class.border-bottom]="panel2.expanded">
        <mat-panel-title
          class="text-uppercase d-flex align-items-center"
          matTooltip="AI takes help of added Documents while responding to guests"
        >
          <i class="fas mr-1" [ngClass]="'fa-caret-' + (panel2.expanded ? 'down' : 'right')"></i> Documents
        </mat-panel-title>
        <mat-panel-description class="d-flex" (click)="$event.stopPropagation()">
          <div class="flex-fill"></div>
          <app-form-switch
            matTooltip="Include or exclude uploaded documents from TokeetAI generated responses."
            label="Active"
            [labelReverse]="true"
            [ctrl]="togglesForm.get('isDocumentsEnabled')"
          ></app-form-switch>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ai-responder-documents [documents]="aiSettings?.docs"></ai-responder-documents>
    </mat-expansion-panel>
    <mat-expansion-panel class="border-bottom rounded-0 shadow-none m-0" #panel3>
      <mat-expansion-panel-header [class.border-bottom]="panel3.expanded">
        <mat-panel-title
          class="text-uppercase d-flex align-items-center"
          matTooltip="AI takes help of added FAQs while responding to guests"
        >
          <i class="fas mr-1" [ngClass]="'fa-caret-' + (panel3.expanded ? 'down' : 'right')"></i> FAQ
        </mat-panel-title>
        <mat-panel-description class="d-flex" (click)="$event.stopPropagation()">
          <div class="flex-fill"></div>
          <app-form-switch
            matTooltip="Include or exclude added FAQs from TokeetAI generated responses."
            label="Active"
            [labelReverse]="true"
            [ctrl]="togglesForm.get('isFaqEnabled')"
          ></app-form-switch>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ai-responder-faq *ngIf="panel3.expanded" [faqs]="aiSettings?.faqs"></ai-responder-faq>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
<ng-template #settings>
  <form [formGroup]="settingsForm" novalidate>
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem" class="p-4">
      <div class="bg-light p-3 rounded">
        <div class="form-group">
          <label class="form-label text-black">AI Name <sup class="text-danger">*</sup></label>
          <input
            type="text"
            class="form-control"
            formControlName="name"
            matTooltip="This name will appear in AI based message signature which is sent to guests."
            matTooltipPosition="above"
          />
          <div
            class="invalid-feedback d-block"
            *ngIf="settingsForm.get('name').hasError('required') && settingsForm.get('name').touched"
          >
            AI Name is required
          </div>
        </div>
        <div>
          <div class="text-black">Select Channel</div>
          <ng-select
            [items]="channels$ | async"
            [formControl]="settingsForm.get('channels')"
            [multiple]="true"
            bindValue="id"
            bindLabel="name"
            appearance="outline"
            appendTo="body"
            class="channel-select"
            matTooltip="It determines which channels the AI responds to. Applied to All if no channel is selected. "
            matTooltipPosition="above"
          >
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <div class="d-flex align-items-center">
                <div class="rounded-circle bg-light border p-1 mr-1 d-inline-flex align-items-center channel-icon">
                  <img [src]="item.id | inquirySourceIcon" />
                </div>
                {{ item.name | titleCase }}
                <a href="javascript:;" (click)="clear(item)" class="ml-1" style="color: #668d98"
                  ><i class="fas fa-times-circle"></i
                ></a>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="d-flex align-items-center">
                <div
                  class="rounded-circle bg-light border p-1 mr-1 d-inline-flex align-items-center"
                  style="width: 25px; height: 25px"
                >
                  <img [src]="item.id | inquirySourceIcon" class="w-100" />
                </div>
                {{ item.name | titleCase }}
              </div>
            </ng-template>
          </ng-select>
        </div>
        <div class="d-flex flex-column" style="gap: 1rem; font-size: 15px">
          <div
            class="d-flex align-items-center"
            [class.text-black]="settingsForm.get('isAutoRespondToNewBookings').value"
            [class.text-bold]="settingsForm.get('isAutoRespondToNewBookings').value"
          >
            Automatically respond to new bookings
            <app-form-switch
              class="ml-auto"
              matTooltip="Automatically send TokeetAI’s generated replies to new booking inquiries"
              matTooltipPosition="right"
              label=""
              [ctrl]="settingsForm.get('isAutoRespondToNewBookings')"
            ></app-form-switch>
          </div>
          <div
            class="d-flex align-items-center"
            [class.text-black]="settingsForm.get('isDelayResponse').value"
            [class.text-bold]="settingsForm.get('isDelayResponse').value"
          >
            Delay response by
            <input
              formControlName="delayResponse"
              class="form-control mx-1"
              matTooltip="Set how many minutes TokeetAI holds off before replying"
              type="number"
              step="1"
              style="width: 80px"
              [class.text-danger]="settingsForm.get('delayResponse').invalid"
            />
            minutes
            <app-form-switch
              class="ml-auto"
              matTooltip="Set a time delay for TokeetAI’s automated responses to guests."
              matTooltipPosition="right"
              label=""
              [ctrl]="settingsForm.get('isDelayResponse')"
            ></app-form-switch>
          </div>
          <div *ngIf="settingsForm.get('delayResponse').invalid">
            <mat-error *ngIf="settingsForm.get('delayResponse').errors?.min"
              >Delay response must be greater than 1</mat-error
            >
            <mat-error *ngIf="settingsForm.get('delayResponse').errors?.integer"
              >Delay response must be integer</mat-error
            >
          </div>
          <div
            class="d-flex align-items-center"
            [class.text-black]="settingsForm.get('isRespondEvenIfResponded').value"
            [class.text-bold]="settingsForm.get('isRespondEvenIfResponded').value"
          >
            Respond even if human response is already sent
            <app-form-switch
              class="ml-auto"
              matTooltip="Allow AI to reply even after a manual response has been sent."
              matTooltipPosition="right"
              label=""
              [ctrl]="settingsForm.get('isRespondEvenIfResponded')"
            ></app-form-switch>
          </div>
          <div class="row">
            <div
              class="col-sm-6"
              matTooltip="Limit the number of automatic replies sent to guests in a single conversation"
              matTooltipPosition="right"
            >
              <div class="d-flex align-items-center">
                <div class="text-nowrap">Maximum Replies</div>
                <input type="number" class="form-control mx-1" formControlName="maxReplies" style="width: 80px" />
              </div>
              <div *ngIf="settingsForm.get('maxReplies').invalid">
                <mat-error *ngIf="settingsForm.get('maxReplies').errors?.required"
                  >Maximum Replies is required</mat-error
                >
                <mat-error *ngIf="settingsForm.get('maxReplies').errors?.min"
                  >Maximum Replies must be greater than 1</mat-error
                >
                <mat-error *ngIf="settingsForm.get('maxReplies').errors?.integer"
                  >Maximum Replies must be integer</mat-error
                >
              </div>
            </div>
          </div>
          <div
            class="d-flex align-items-center"
            [class.text-black]="settingsForm.get('isCreateDrafts').value"
            [class.text-bold]="settingsForm.get('isCreateDrafts').value"
          >
            Create draft replies
            <app-form-switch
              class="ml-auto"
              matTooltip="Allow AI to create draft message when guest messages are received."
              matTooltipPosition="right"
              label=""
              [ctrl]="settingsForm.get('isCreateDrafts')"
            ></app-form-switch>
          </div>
          <div
            class="d-flex align-items-center"
            [class.text-black]="settingsForm.get('notification').value"
            [class.text-bold]="settingsForm.get('notification').value"
          >
            Notify Me by AI
            <app-form-switch
              class="ml-auto"
              matTooltip="Email Notification will be sent out to Tokeet Account email address  by AI if guest orders or complain about any thing. "
              matTooltipPosition="right"
              label=""
              [ctrl]="settingsForm.get('notification')"
            ></app-form-switch>
          </div>
          <div
            class="d-flex align-items-center"
            [class.text-black]="settingsForm.get('ignoreCourtesies').value"
            [class.text-bold]="settingsForm.get('ignoreCourtesies').value"
          >
            Ignore Courtesies
            <app-form-switch
              class="ml-auto"
              matTooltip="Ignore OK, Thank you, and similar messages"
              matTooltipPosition="right"
              label=""
              [ctrl]="settingsForm.get('ignoreCourtesies')"
            ></app-form-switch>
          </div>
        </div>
      </div>
      <div class="bg-light p-3 rounded">
        <label class="d-block mb-3 text-black">
          Tone of Voice
          <i
            class="fal fa-info-circle"
            matTooltip="Set the tone for how the AI will chat with guests."
            matTooltipPosition="above"
          ></i>
        </label>
        <mat-radio-group formControlName="tone" class="d-flex flex-column" style="gap: 1rem">
          <ng-container *ngFor="let item of toneOptions">
            <mat-radio-button [value]="item.id">
              <div>
                <div class="text-black text-bold">{{ item.label }}</div>
                <div class="text-muted" style="font-size: 12px">{{ item.example }}</div>
              </div>
            </mat-radio-button>
          </ng-container>
        </mat-radio-group>
      </div>
    </div>
    <div class="d-flex px-4 pb-4">
      <button
        class="btn btn-success ml-auto text-uppercase"
        matTooltip="Save your changes every time you make any change in AI Settings"
        [disabled]="isSaving$ | async"
        (click)="onSaveSettings(settingsForm)"
      >
        <i class="fa fa-save"></i> Save
      </button>
    </div>
  </form>
</ng-template>

<ng-template #test>
  <form [formGroup]="testForm" style="font-size: 14px">
    <div>
      <div
        class="bg-tokeet-blue text-white rounded-top p-3 d-flex align-items-center"
        style="margin: -0.5rem -0.75rem 0"
      >
        <div
          class="rounded-circle bg-white d-flex align-items-center justify-content-center mr-3"
          style="height: 80px; width: 80px; min-width: 80px; min-height: 80px"
        >
          <svg-icon src="assets/images/icons/ai.svg" [svgStyle]="{ 'width.px': 35, color: '#1EBDD3' }"></svg-icon>
        </div>
        <div>Chat with me now that your bot has been trained and I'll do my best to answer.</div>
      </div>
      <div class="mx-4 mt-4">
        <div class="row">
          <div class="col-md-12">
            <div>Rental <sup class="text-danger">*</sup></div>
            <ng-select
              bindValue="id"
              bindLabel="name"
              [multiple]="false"
              [clearable]="false"
              [items]="rentals$ | async"
              [formControl]="testForm.get('rentalId')"
              appearance="outline"
            >
            </ng-select>
          </div>
          <div class="col-md-12">
            <div>Inquiry <sup class="text-danger">*</sup></div>
            <ng-select
              bindValue="id"
              bindLabel="guestDetails.name"
              [multiple]="false"
              [clearable]="false"
              [items]="bookings$ | async"
              [formControl]="testForm.get('inquiryId')"
              [loading]="isLoadingBookings"
              appearance="outline"
            >
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div style="line-height: 1.5" class="py-2">
                  <div class="text-truncate">
                    <b>{{ item.guestDetails?.name }}</b> at {{ item.rentalId | rentalName | async }}
                  </div>
                  <small class="text-muted">
                    starting {{ item.guestArrive | epoch : 'DD - MMM - YYYY' }} ending
                    {{ item.guestDepart | epoch : 'DD - MMM - YYYY' }}
                  </small>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-12">
            <div>Tone of Voice <sup class="text-danger">*</sup></div>
            <ng-select
              bindValue="id"
              bindLabel="label"
              [clearable]="false"
              [multiple]="false"
              [items]="toneOptions"
              [formControl]="testForm.get('tone')"
              appearance="outline"
            >
            </ng-select>
          </div>
        </div>
        <div>Question <sup class="text-danger">*</sup></div>
        <textarea
          class="border rounded p-3 w-100"
          rows="5"
          formControlName="message"
          placeholder="Ask questions based on the documents/FAQs you added in Knowledge base"
        ></textarea>
        <mat-error *ngIf="testForm.get('message').touched && testForm.get('message').errors?.required">
          Question is required
        </mat-error>
        <div
          class="border rounded p-3 mt-3 w-100 bg-light"
          *ngIf="!!testForm.get('answer').value"
          style="height: 200px; overflow: auto"
        >
          <div [innerHtml]="testForm.get('answer').value"></div>
        </div>
      </div>
      <div class="d-flex justify-content-end mx-4 my-2">
        <button class="btn btn-outline btn-default-outline text-uppercase ml-3" (click)="testPop.hide()">
          <i class="far fa-times"></i> Cancel
        </button>
        <button
          class="btn btn-success text-uppercase ml-3"
          [disabled]="!isTestFormChanged || !testForm.valid || isGeneratingResponse"
          (click)="onTest(testForm)"
        >
          Send
          <i class="fa fa-spin fa-spinner" *ngIf="isGeneratingResponse"></i>
          <img
            *ngIf="!isGeneratingResponse"
            style="height: 12px; position: relative; top: -2px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA3klEQVR4nL3VsUqCURjGcTManAQbG4JAugOXHFsDr+C7BcdWR6HJsQYHL0FvwZoaamgIHJoEFyG+pUV+EZwDEQ2ivt//At7/4TzPe06tFg2eUeA4SpBZoI9GlCCzwgCnUYJMiXu0owSZDWboRAl+M8cNjqIEmdfUvJMoQWaZCtGMEmQ+McLZf4I7jDHFE96xthtfeMDltvk0cIFuCrdIyzjEJLXrJ/i3P4fKzbuOFlzFX5EKQt6HD9xG1PQlatHmEU/FJuqxK1Nw5zsN3uLDae01uMov8xE91A86uCq+AUn+O8EZtO0KAAAAAElFTkSuQmCC"
          />
        </button>
      </div>
    </div>
  </form>
</ng-template>
